import CoachMarketPlaceView from './CoachMarketPlaceView'
export default CoachMarketPlaceView
